export const TargetType = {
  Account: "Account",
  Physical: "Physical",
  Juridical: "Juridical",
};

export const PersonType = {
  All: "All",
  Physical: "Physical",
  Juridical: "Juridical",
};

export const CivilStatus = {
  Single: "Single",
  Engaged: "Engaged",
  Married: "Married",
  Divorced: "Divorced",
  Widower: "Widower",
  Other: "Other",
};

export function getTargetTypeName(type) {
  return type;
}

export const PhysicalPersonRelationshipAccount = {
  Attorney: "Attorney",
  Holder: "Holder",
  Authorized: "Authorized",
  Other: "Other",
  WebAuthorized: "WebAuthorized",
};

export const PhysicalPersonRelationshipAccountJuridical = {
  Attorney: "Attorney",
  Representative: "Representative",
  None: "None",
  WebAuthorized: "WebAuthorized",
  Holder: "Holder",
};

export const OptionsWhyWithoutTIN = [
  {
    id: "Option1",
    text: "El país donde el titular de la cuenta está sujeto a impuestos tributarios como residente no emite TIN.",
  },
  {
    id: "Option2",
    text: "El titular de la cuenta está imposibilitado de otra manera para obtener un TIN o número equivalente.",
  },
  {
    id: "Option3",
    text: "No se requiere TIN porque la jurisdicción de la residencia fiscal que emitió el TIN no exige que una Institución Financiera recolecte e informe el TIN.",
  },
];

export const DocumentType = {
  DNI: "DNI",
  Passport: "Passport",
  IdentityCard: "Identity Card",
};

export const PersonStatus = {
  Active: "Active",
  Inactive: "Inactive",
  PassedAway: "Passed Away",
};

export const Gender = {
  N: "Not Specified",
  M: "Male",
  F: "Female",
};

export const BankAccountType = {
  Current: "Current",
  Savings: "Savings",
  Other: "Other"
};

export const BankAccountStatus = {
  Active: "Active",
  Inactive: "Inactive"
};

export const RelatedFrom = {
  FaceToFace : "Face To Face",
  App : "App",
  Web : "Web",
  Digital: "Digital"
};

export const shareType = [
  { 
  id: 'BearerShare' ,  name: "Bearer Share"},{
  id: 'RegisteredShare', name: "Registered Share"},{
  id: 'NotDefined', name: "Not Defined"},
];

export const CurrencyType = {
  Local : "Local",
  Foreign : "Foreign",
  Both : "Both",
};

export const KYCStatus = {
  Approved : "Approved",
  Rejected : "Rejected",
  New : "New",
  AuthWaiting : "Auth.Waiting",
  New : "New",
  Matured : "Matured",
  DigitalApproved: "DigitalApproved"
};

export const KYCReason = {
  Renovation : "Renovation",
  Advanced : "Advanced",
  RiskChanged : "Risk Changed",
  New : "New",
  Digital: "Digital"
};

